import api from "./api";

// Profit month by month, and the ratios read off it.
const url = "/api/admin/finance";

/** Months are inclusive and look like 2026-09. Blank means the last six months. */
export const getFinanceSummary = async ({ fromMonth, toMonth } = {}) => {
  const { data } = await api.get(`${url}/summary`, {
    params: { fromMonth: fromMonth || undefined, toMonth: toMonth || undefined },
  });
  return data;
};
